import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";

export default function Edit(props) {
  const { params } = props.match;
  const userId = parseInt(params.id, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [user, setUser] = React.useState(null);

  const replaceFeatures = [
    {id: 10, name: "administrator"},
    {id: 20, name: "account"},
    {id: 30, name: "csvReport"},
    {id: 40, name: "customer"},
    {id: 50, name: "info"},
    {id: 60, name: "informationUrls"},
    {id: 70, name: "dtm"},
    {id: 80, name: "dtmSetting"},
    {id: 90, name: "mediaAccounts"},
    {id: 95, name: "mediaCategories"},
    {id: 9999, name: "log"},
  ];

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 管理者編集";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAdmin();
  }, [auth.state.token]);

  const fetchAdmin = () => {
    request({
      method: "GET",
      url: `admin/users/${userId}`,
    }).then((result) => {
      // 選択済み利用可能機能をフォーマッティング
      let selectedFeatures = {
        administrator: false,
        account: false,
        csvReport: false,
        customer: false,
        info: false,
        informationUrls: false,
        dtm: false,
        dtmSetting: false,
        mediaAccounts: false,
        mediaCategories: false,
        log: false,
      };

      (result.data.data.features).map((feature) => {
        replaceFeatures.map((value) => {
          if (value.id === feature) {
            selectedFeatures[value.name] = true;
          }
        })
      })

      let userData = { 
        adminName: result.data.data.name, 
        desc: result.data.data.desc, 
        email: result.data.data.email, 
        features: selectedFeatures,
      }
      setUser(userData);
    });
  }

  const handleSubmit = ({ adminName, desc, email, features }) => {
    // 選択した利用可能機能をフォーマッティング
    let selectFeatures = [];
    replaceFeatures.map((value) => {
      if (features[value.name]) {
        selectFeatures.push(value.id);
      }
    })

    request({
      method: "PUT",
      url: `admin/users/${userId}`,
      data: {
        name: adminName,
        desc: desc,
        email: email,
        features: selectFeatures,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/administrator?success=edit");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          user={user}
          isEdit={true}
        />
      }
    />
  );
}
